import { tassign } from 'tassign';

import * as LSMgmt from '@core/redux/localstorage';
import * as Store from '@core/redux/stores';

// REDUX should be only used to track data needed by multiple features that
// require the data to be persistant. Also, any data required from redux
// is going to need to have a reasonable reliability of forcing
// the user to input or retrieve the data.
// Data storage in redux is EXPENSIVE performance wise. Do not mis-use this.

export function rootReducer(state: Store.IAppState, action: Store.Action): Store.IAppState {
  switch (action.type) {
    case Store.Actions.USERLOGGEDIN:
      const userAuthPayload = <Store.AuthResponse>action.data;
      const tokenInfo = userAuthPayload.tokenInfo;
      const user = userAuthPayload.user;
      return tassign(state, { auth: { isLoggedIn: true, tokenInfo: tokenInfo }, user: user });
    case Store.Actions.UPDATEUSERPROFILE:
      const userProf = action.data;
      return tassign(state, { user: userProf });
    case Store.Actions.USERLOGGEDOUT:
      LSMgmt.deleteState();
      return tassign(state, Store.INITIAL_STATE);
    case Store.Actions.USERTOKENREFRESHED:
      const incomingToken = <Store.TokenInfo>action.data;
      const priorToken = state.auth?.tokenInfo;
      const mergedToken = new Store.TokenInfo();
      mergedToken.accessToken = incomingToken.accessToken ?? priorToken?.accessToken ?? null;
      mergedToken.expiresIn = incomingToken.expiresIn ?? priorToken?.expiresIn ?? null;
      mergedToken.tokenType = incomingToken.tokenType ?? priorToken?.tokenType ?? null;
      mergedToken.refreshToken =
        incomingToken.refreshToken != null && incomingToken.refreshToken !== ''
          ? incomingToken.refreshToken
          : (priorToken?.refreshToken ?? null);
      return tassign(state, {
        auth: { isLoggedIn: true, tokenInfo: mergedToken }
      });
    case Store.Actions.UPDATEUSERAVATAR:
      const newAvatarData = new Store.User();
      newAvatarData.avatarId = action.data.imageId;
      newAvatarData.profileImageType = action.data.imageType;
      return tassign(state, { user: newAvatarData });
    case Store.Actions.SETLOCATIONSELECTED:
      const location = <Store.LocationsEntity>action.data;
      return tassign(state, { locationSelected: location });
    case Store.Actions.CLEARLOATIONSELECTED:
      return tassign(state, { locationSelected: null });
    case Store.Actions.UPDATEORDER:
      return tassign(state, { activeOrder: <Store.Order>action.data });
    case Store.Actions.CLEARORDER:
      return tassign(state, { activeOrder: null });
    case Store.Actions.UPDATEFAVORITE:
      return tassign(state, { activeFavorite: <Store.Order>action.data });
    case Store.Actions.CLEARFAVORITE:
      return tassign(state, { activeFavorite: null });
    case Store.Actions.UPDATELASTORDER:
      return tassign(state, { lastOrder: <Store.Order>action.data });
    case Store.Actions.UPDATEPICKUPTYPE:
      return tassign(state, { pickuptypeSelected: <Store.PickupType>action.data });
    case Store.Actions.SUBMITTEDORDER:
      return tassign(state, { submittedOrder: <Store.UserOrderInfo>action.data });
    case Store.Actions.CONFIRMANDPAY:
      return tassign(state, { confirmAndPay: <Store.ConfirmAndPay>action.data });
    case Store.Actions.CONFIRMANDPAYORDER:
      return tassign(state, { confirmAndPayOrder: <Store.SubmitOrderRequest>action.data });
    case Store.Actions.GUESTLOGIN:
      return tassign(state, { guest: <Store.CustomerInfo>action.data });
    case Store.Actions.ORDERPAYMENTINFO:
      return tassign(state, { orderPaymentInfo: <Store.OrderPaymentInfo>action.data });
    case Store.Actions.ORDERGUESTPAYMENTINFO:
      return tassign(state, { orderGuestPaymentInfo: <Store.OrderGuestPaymentInfo>action.data });
    case Store.Actions.CONTACTUS:
      return tassign(state, { contactUs: <Store.ContactUs>action.data });
    case Store.Actions.FRANCHISE:
      return tassign(state, { franchise: <Store.Franchise>action.data });
    case Store.Actions.VIRTUALGIFTCARD:
      return tassign(state, { virtualGiftCard: <Store.VirtualGiftCard>action.data });
    case Store.Actions.SUBMITTEDGIFTCARDORDER:
      return tassign(state, { virtualGiftCardOrder: <Store.VirtualGiftCardOrder>action.data });
    case Store.Actions.CLEARVIRTUALGIFTCARD:
      return tassign(state, { virtualGiftCard: null });
    case Store.Actions.BRAZEUSER:
      return tassign(state, { brazeUser: <Store.BrazeUser>action.data });
    case Store.Actions.CLEARBRAZEUSER:
      return tassign(state, { brazeUser: null });
    case Store.Actions.NONFOODORDER:
      return tassign(state, { nonFoodOrder: <Store.NonFoodOrder>action.data });
    case Store.Actions.CONTACTUSPROBLEM:
      return tassign(state, { contactUsProblem: <Store.ContactUsProblem>action.data });
    default:
      return state;
  }
}
